
import PropTypes from 'prop-types'
import React from 'react'
import { FlexItem } from '../flexgrid'
import './content.css'

const Content = props => (
  <FlexItem flex={1}>
    <div className='InfoSheetContent'>
      {props.children}
    </div>
  </FlexItem>
)

Content.propTypes = {
  children: PropTypes.array.isRequired
}

Content.displayName = 'InfoSheet Content'

export default Content



// WEBPACK FOOTER //
// ./ui/InfoSheet/content.js